package ai.wagemix.web.screens

import androidx.compose.runtime.Composable
import com.fsryan.foundation.logic.prompting.FSPromptingPresenter
import com.fsryan.foundation.web.screens.FSBasePromptDialog

/**
 * Routes a feature prompt: the feature's `ComposedSuperPrompt` is unwrapped by [unwrap] and
 * rendered by foundation's dialog (which renders nothing for `none()`); anything else goes to
 * [renderFeature]. Nothing here responds to a prompt during composition.
 */
@Composable
fun <P: FSPromptingPresenter.Prompt> WMPromptDialog(
    prompt: P,
    unwrap: (P) -> FSPromptingPresenter.Prompt.Base?,
    strings: WMWebStrings,
    onResponse: (Int) -> Unit,
    renderFeature: @Composable (P) -> Unit
) {
    when (val base = unwrap(prompt)) {
        null -> renderFeature(prompt)
        else -> FSBasePromptDialog(prompt = base, onResponse = onResponse, strings = strings.basePrompts) {}
    }
}
